// import "../css/style.css";
import icespice from "../css/img/icespice-logo.png";
import check from "../css/img/check.png";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { BottomSheetCustom } from "@cred/neopop-web/lib/components";
import BottomLoginDirect from "./bottomLoginDirect";
import UrlPopup from "../components/UrlPopup";

function PopUp() {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showUrlPopup, setShowUrlPopup] = useState(false);
  const [currentUrl, setCurrentUrl] = useState("");

  let session_token = searchParams.get("session_token");
  let page = searchParams.get("page");
  console.log("Location in PopUp:", location.search, page);
  useEffect(() => {
    // if (!session_token || session_token === localStorage.getItem("sessionId")) {
    //   session_token = localStorage.getItem("sessionId");
    // } else {
    //   localStorage.clear();
    //   localStorage.setItem("sessionId", session_token);
    // }

    if (page === "detail") {
      setCurrentUrl(window.location.href);
      setShowUrlPopup(true);
    } else if (page === "form") {
      setShowLoginPopup(true);
    } else if (page === "refer") {
      // navigate("/refer", { replace: true });
      navigate(`/s/${session_token}?nocache=${Date.now()}&page=refer`, {
        replace: true,
      });
    } else if (page === "chakra") {
      // navigate("/rewards-chakra", { replace: true });
      navigate(`/s/${session_token}?nocache=${Date.now()}&page=chakra`, {
        replace: true,
      });
    } else {
      // Default redirection if no specific page parameter or invalid
      navigate(`/s/${session_token}?nocache=${Date.now()}`, { replace: true });
    }
  }, [session_token, page, navigate]);

  const handleCloseLoginPopup = () => {
    setShowLoginPopup(false);
    navigate("/home", { replace: true }); // Redirect after closing login popup
  };

  const handleCloseUrlPopup = () => {
    setShowUrlPopup(false);
    navigate("/home", { replace: true }); // Redirect after closing URL popup
  };

  return (
    <HelmetProvider>
      <Helmet>
        <title>Authentication</title>
      </Helmet>
      {showUrlPopup && (
        <UrlPopup url={currentUrl} onClose={handleCloseUrlPopup} />
      )}
      {/* {showLoginPopup && (
        <BottomSheetCustom
          open={showLoginPopup}
          handleClose={handleCloseLoginPopup}
          maxHeight="700px"
        >
          <BottomLoginDirect reredirect={location.pathname} />
        </BottomSheetCustom>
      )} */}
    </HelmetProvider>
  );
}

export default PopUp;
